// Auto-invalidate prompt fragments cache on mutating API calls
// Client-only plugin since caching is in client state via useState

export default defineNuxtPlugin(() => {
  // Methods that mutate server state
  const MUTATING = new Set(['POST', 'PUT', 'PATCH', 'DELETE'])

  // Create a wrapped $fetch with a response interceptor
  const wrapped = $fetch.create({
    onResponse(ctx) {
      try {
        const method = String(ctx.options?.method || 'GET').toUpperCase()
        const url = typeof ctx.request === 'string' ? ctx.request : ctx.request?.url || ''

        if (MUTATING.has(method) && url.includes('/api/prompt-fragments')) {
          // Invalidate cache TTL so the next read will refresh
          const { invalidateFragmentsCache } = usePromptFragments()
          invalidateFragmentsCache()
        }
      } catch (e) {
        // Silently ignore to avoid breaking requests
        console.warn('[prompt-fragments-cache] Failed to invalidate cache:', e)
      }
    }
  })

  // Replace global $fetch with wrapped instance
  // This keeps existing usage intact while adding the interceptor
  // @ts-expect-error override global instance for client runtime
  globalThis.$fetch = wrapped
})
